<template>
  <div class="rrj-play-wrapper">
    <video
      :id="'txplayer' + video.fileId"
      class="rrj-txplayer"
      width="800"
      height="450"
      preload="auto"
      playsinline
      webkit-playsinline
    ></video>
    <div @click="closePlayer" class="player-close">
      <i class="el-icon-error"></i>
    </div>
  </div>
</template>

<script>
import TCPlayer from "tcplayer.js";
// import "tcplayer.js/dist/tcplayer.min.css";

export default {
  name: "SourceVideoPreview",
  props: {
    video: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  data() {
    return {
      player: null, // 新增播放器实例引用
    };
  },
  mounted() {
    console.log("this.video====1", this.video);
    this.initPlayer();
  },
  methods: {
    closePlayer() {
      this.$emit("close");
    },
    initPlayer() {
      console.log(this.video);
      // 先销毁旧的播放器
      if (this.player) {
        this.player.dispose();
      }

      if (this.video) {
        const Button = TCPlayer.getComponent("Button");
        const BigPlayButton = TCPlayer.getComponent("BigPlayButton");
        BigPlayButton.prototype.createEl = function () {
          var el = Button.prototype.createEl.call(this);
          let _html =
            '<div class="rrj-play-btn"><svg t="1744042190566" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1503" width="32" height="32"><path d="M897.143467 597.051733l-464.648534 311.5264c-46.976 31.488-110.592 18.944-142.08-28.023466A102.4 102.4 0 0 1 273.066667 823.5264V200.4736c0-56.5504 45.8496-102.4 102.4-102.4a102.4 102.4 0 0 1 57.028266 17.348267l464.64 311.5264c46.976 31.488 59.528533 95.104 28.032 142.08a102.4 102.4 0 0 1-28.023466 28.023466z" p-id="1504" fill="#ffffff"></path></svg></div>';

          el.appendChild(
            TCPlayer.dom.createEl("div", {
              className: "vjs-button-icon",
              innerHTML: _html,
            })
          );
          return el;
        };

        if (this.video.url) {
          this.player = TCPlayer("txplayer" + this.video.fileId, {
            sources: [
              {
                src: "https://qcloudvod.renrenjiang.cn/80ddb38fvodtransgzp1255652068/65787bb71397757907976460074/v.f1425240.m3u8", // 播放地址
              },
            ],
            poster: this.video.holder,
            licenseUrl:
              "https://license.vod2.myqcloud.com/license/v2/1255652068_1/v_cube.license",
          });
          console.log(this.player);
        } else if (this.video.token) {
          this.player = TCPlayer("txplayer" + this.video.fileId, {
            fileID: this.video.fileId,
            appID: this.video.appId,
            psign: this.video.token,
            poster: this.video.holder,
            licenseUrl:
              "https://license.vod2.myqcloud.com/license/v2/1255652068_1/v_cube.license",
          });
          console.log(this.player);
        }
      }
    },
  },
  // 添加组件销毁钩子
  beforeDestroy() {
    if (this.player) {
      this.player.dispose(); // 销毁播放器
      this.player = null;
    }
  },
};
</script>

<style lang="scss" scoped>
.rrj-play-wrapper {
  position: relative;
  width: 800px;
  height: 450px;
}

.rrj-txplayer {
  width: 800px;
  height: 450px;
}

.player-close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 232x;
  height: 32px;
  border-radius: 50%;
  // background-color: #ffffff;
  // background-color: rgba($color: #000000, $alpha: 0.6);

  text-align: center;
  line-height: 32px;
  font-size: 28px;
  color: #ffffff;
  cursor: pointer;
}
</style>

<style lang="scss">
.rrj-play-btn {
  width: 70px;
  height: 70px;
  cursor: pointer;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: rgba($color: #000000, $alpha: 0.4);

  &:hover {
    background-color: rgba($color: #000000, $alpha: 0.6);
  }
}

.rrj-txplayer .vjs-play-progress {
  background-color: #0366ff;
}
// .rrj-txplayer .vjs-play-control.vjs-playing .vjs-icon-placeholder:before {
//   color: #0366ff;
// }
// .rrj-txplayer .vjs-play-control.vjs-ended .vjs-icon-placeholder:before {
//   color: #0366ff;
// }
// .rrj-txplayer .vjs-play-control .vjs-icon-placeholder:before {
//   color: #0366ff;
// }
.rrj-txplayer .vjs-volume-panel .vjs-volume-level {
  background-color: #0366ff;
}
// .rrj-txplayer .vjs-mute-control .vjs-icon-placeholder:before {
//   color: #0366ff;
// }
</style>
